export const environment = {
  production: '#{isProd}#',
  api: '#{p2V2api}#',
};
